import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Stack, Chip } from '@mui/material';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo/LogoSection';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
    const theme = useTheme();

    return (
        // only available in paid version
        (<DrawerHeaderStyled theme={theme} open={open} style={{ backgroundColor: '#151f57' }}>
            <Stack direction="row" spacing={1} alignItems="center">
                <Logo />
                <Chip
                    label={process.env.REACT_APP_VERSION}
                    size="small"
                    color="primary"
                    clickable={false}
                    sx={{ height: 'auto', '& .MuiChip-label': { fontSize: '0.625rem', py: 0.25 } }}
                />
            </Stack>
        </DrawerHeaderStyled>)
    );
};

DrawerHeader.propTypes = {
    open: PropTypes.bool
};

export default DrawerHeader;
